import {
    SET_MAKES,
    SET_MODELS,
    SET_SELECT_MAKE,
    SET_SELECT_MODEL,
    SET_SELECT_SIZE,
    SET_SELECT_TRIM,
    SET_SELECT_YEAR,
    SET_SIZES,
    SET_TRIMS,
    SET_YEARS,
    SET_ZIPCODE
} from "./ActionTypes";

const initialState = {
    years: [],
    makes: [],
    models: [],
    trims: [],
    sizes: [],
    zipCode: '',
    sYear: '',
    sMake: '',
    sModel: '',
    sTrim: '',
    sSize: '',
};

const yearMakeModelReducer = (state = initialState, action) => {
    if (action.payload) {
        switch (action.type) {
            case SET_YEARS: {
                return Object.assign({}, state, {
                    newState: (state.years = action.payload),
                });
            }
            case SET_MAKES: {
                return Object.assign({}, state, {
                    newState: (state.makes = action.payload),
                });
            }
            case SET_MODELS: {
                return Object.assign({}, state, {
                    newState: (state.models = action.payload),
                });
            }
            case SET_TRIMS: {
                return Object.assign({}, state, {
                    newState: (state.trims = action.payload),
                });
            }
            case SET_SIZES: {
                return Object.assign({}, state, {
                    newState: (state.sizes = action.payload),
                });
            }
            case SET_ZIPCODE: {
                if (action.payload === 'empty') {
                    action.payload = 'empty';
                }
                return Object.assign({}, state, {
                    newState: (state.zipCode = action.payload),
                });
            }
            case SET_SELECT_YEAR: {
                return Object.assign({}, state, {
                    newState: (state.sYear = action.payload),
                });
            }
            case SET_SELECT_MAKE: {
                return Object.assign({}, state, {
                    newState: (state.sMake = action.payload),
                });
            }
            case SET_SELECT_MODEL: {
                return Object.assign({}, state, {
                    newState: (state.sModel = action.payload),
                });
            }
            case SET_SELECT_SIZE: {
                return Object.assign({}, state, {
                    newState: (state.sSize = action.payload),
                });
            }
            case SET_SELECT_TRIM: {
                return Object.assign({}, state, {
                    newState: (state.sTrim = action.payload),
                });
            }
            default:
                return state;
        }
    } else {
        return state;
    }
};

export default yearMakeModelReducer;
